import {Hydra} from '../generic/hydra';

import {PersonneInterface} from './Personne';
import {ExpertSaisieListInterface} from './ExpertSaisieList';
import {MotCleInterface} from './MotCle';
import {ExpertSaisie as ExpertSaisieBaseInterface} from '../../interface/api/ExpertSaisie';

export type ExpertSaisieInterface = ExpertSaisieBaseInterface;

export class ExpertSaisie extends Hydra implements ExpertSaisieInterface {

    id?: number | null;

    personne?: PersonneInterface | string | null;

    email?: string | null;

    laboratoire?: string | null;

    ville?: string | null;

    /* Country, sous forme d'IRI ou d'objet
     */
    pays?: any | null;

    expertSaisieList?: ExpertSaisieListInterface | string | null;

    expertises?: MotCleInterface[] | null;

    position?: number | null;


    constructor(options: ExpertSaisieInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
